import React from 'react';
import { Input } from 'antd';

const MultilineInput = ({ value, onChange, ...rest }) => {
  const stringValue = value?.join('\n');

  const onTextAreaChanged = (e) => {
    onChange(e.target.value?.split('\n'));
  };

  return <Input.TextArea value={stringValue} onChange={onTextAreaChanged} autoSize={{ minRows: 2, maxRows: 10 }} {...rest} />;
};

export default MultilineInput;
